import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import AppTheme from './shared-theme/AppTheme.js'; // ✅ it's a component
import Blog from './blog/Blog.js';

function App() {
  return (
    <AppTheme>
      <Blog />
    </AppTheme>
  );
}

export default App;